import { render, staticRenderFns } from "./ReportCommunityModal.vue?vue&type=template&id=8551b984&scoped=true"
import script from "./ReportCommunityModal.vue?vue&type=script&lang=js"
export * from "./ReportCommunityModal.vue?vue&type=script&lang=js"
import style0 from "./ReportCommunityModal.vue?vue&type=style&index=0&id=8551b984&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8551b984",
  null
  
)

export default component.exports